import { PropsWithChildren } from 'react'

export const H4 = ({
  children,
  onClick,
}: PropsWithChildren<{ onClick: () => void }>) => (
  <h4
    className="text-white text-[26px] font-decimal font-bold pb-1"
    role="button"
    onClick={onClick}
  >
    {children}
  </h4>
)

interface MobileMenuProps {
  label: string
  onNavigate: () => void
}

function NavMenuItem({ label, onNavigate }: MobileMenuProps) {
  return (
    <div>
      <H4 onClick={onNavigate}>{label}</H4>
      <hr className="border-[1px] border-white" />
    </div>
  )
}

export default NavMenuItem
